<template>
  <v-card :loading="loading" class="pa-2" flat>
    <v-tabs v-model="tabs" grow>
      <v-tab>درگاه ها</v-tab>
      <v-tab>درگاه های تاپ (top)</v-tab>
      <v-tab>تراکنش های درگاه مستقیم</v-tab>
    </v-tabs>

    <v-divider class="mt-0" />

    <v-tabs-items v-model="tabs">
      <v-tab-item>
        <data-table
          :columns="columns"
          :data="data"
          :debounce-delay="5000"
          :per-page="[10, 25, 50, 100, 200, 400]"
          :translate="translate"
          orderDir="desc"
          @on-table-props-changed="reloadTable"
        />
      </v-tab-item>

      <v-tab-item>
        <add-top-payment />
      </v-tab-item>

      <v-tab-item>
        <data-table
          :columns="transactionColumns"
          :data="transitionsData"
          :debounce-delay="5000"
          :per-page="[10, 25, 50, 100, 200, 400]"
          :translate="translate"
          orderDir="desc"
          @on-table-props-changed="reloadTableTransaction"
        />
      </v-tab-item>
    </v-tabs-items>
  </v-card>
</template>

<script>
import { SET_BREADCRUMB } from "@/core/services/store/breadcrumbs.module";
import PaymentBtn from "./PaymentBtn";
import transactionsStatusComponent from "@/view/pages/admin/payment/transactionsStatusComponent";
import AddTopPayment from "@/view/pages/admin/payment/addTopPayment.vue";
import paymentChangeStatus from "@/view/pages/admin/payment/paymentChangeStatus.vue";

export default {
  components: { AddTopPayment },

  data() {
    return {
      columns: [
        {
          label: "شناسه",
          name: "id",
          orderable: true,
        },
        {
          label: "نام",
          name: "name",
          orderable: true,
          searchable: true,
        },
        {
          label: "درایور",
          name: "driver",
          orderable: true,
          searchable: true,
        },
        {
          label: "نوع",
          name: "type",
          orderable: true,
          searchable: true,
       transform: (value) => {
  return value.data.type === "regular"
    ? `<span class="badge-pill pa-2 px-3" style="background-color: rgb(244, 193, 100); color: #000; display: inline-block;">حقیقی (غیر رسمی) </span>`
    : `<span class="badge-pill pa-2 px-3" style="background-color: rgb(135, 251, 135); color: #000; display: inline-block;">حقوقی (رسمی) </span>`;
}

        },
        {
          label: "نوع کاربران",
          name: "status",
          orderable: true,
          searchable: true,
          transform: (value) => {
            return !!value.data?.status
              ? value.data.status === "public"
                ? "پیشفرض"
                : "کاربران انتخابی"
              : "-";
          },
        },
        {
          label: "تاریخ ویرایش",
          name: "updated_at",
          orderable: true,
          transform: (val) => {
            return this.$options.filters.longDate(val.data.updated_at);
          },
        },
        {
          label: "عملیات",
          name: "action",
          component: PaymentBtn,
          handler: this.actions,
          event: "actions",
          meta: {
            permission_prefix: "paymentGateway_",
          },
        },
      ],
      transactionColumns: [
        { label: "شناسه", name: "id", orderable: true },
        {
          label: "نام کاربر",
          name: "user.name",
          orderable: true,
          searchable: true,
          transform: (value) => {
            return value.data.user.name + " " + value.data.user.lastName;
          },
        },
        { label: "شناسه کاربر", name: "user_id" },
        { label: "شماره موبایل", name: "phone" },
        { label: "تاریخ درخواست", name: "created_at_p" },
        { label: "تاریخ ویرایش", name: "updated_at_p" },
        { label: "کد گیری بازارپی", name: "order_id" },
        {
          label: "مبلغ",
          name: "amount",
          transform: ({ data }) => {
            return this.persian(this.price(data.amount));
          },
        },
        {
          label: "موجودی",
          name: "wallet",
          transform: ({ data }) => {
            return this.persian(this.price(data.wallet));
          },
        },
        {
          label: "وضعیت",
          name: "status",
          component: transactionsStatusComponent,
        },
        { label: "عمل", name: "action", component: paymentChangeStatus },
      ],
      url: "gatewayPayment",
      translate: {
        nextButton: "بعدی",
        previousButton: "قبلی",
        rowsPerPageText: "تعداد در صفحه",
        noDataText: "داده ای برای نمایش وجود ندارد",
        placeholderSearch: "جستجو",
      },
      tableProps: {
        search: "",
        length: 10,
        column: "id",
        dir: "desc",
      },
      data: {},
      transitionsData: {},
      loading: false,
      tabs: 0,
    };
  },

  created() {
    this.$root.$on("changeStatus", this.reFetch);

    this.getAllPaymentGateways(this.url);
    this.$store.dispatch(SET_BREADCRUMB, [{ title: this.$route.meta.title }]);
  },

  watch: {
    tabs(val) {
      if (val === 2 && !Object.keys(this.transitionsData).length) {
        this.getTransactions();
      }
    },
  },

  methods: {
    getAllPaymentGateways(url = this.url, query = this.tableProps) {
      this.loading = true;
      this.requestApiGet(url, query)
        .then((response) => {
          this.data = response.data;
        })
        .finally(() => (this.loading = false));
    },
    reloadTable(tableProps) {
      this.getAllPaymentGateways(this.url, tableProps);
    },
    reloadTableTransaction(tableProps) {
      this.getTransactions(tableProps);
    },
    actions(data, type) {
      this[type](data);
    },
    edit(data) {
      this.$router.push({
        name: "payment.edit",
        params: { id: data.id },
      });
    },
    getTransactions(query = this.tableProps) {
      this.loading = true;

      axios
        .get(`${this.$robotApi}/admin/bazaar/list`, {
          headers: this.header(),
          params: {
            ...query,
          },
        })
        .then(({ data }) => {
          this.transitionsData = data.data;
        })
        .catch(({ response }) =>
          console.log("error in get transactions: ", response)
        )
        .finally(() => (this.loading = false));
    },
    reFetch() {
      this.reloadTable();
    },
  },
};
</script>
